var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        size: "xl",
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "modal-class": "wizard-custom-document"
      },
      on: { hidden: _vm.resetWizard },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("wizard-header", {
                attrs: { "current-step": _vm.currentStep, "total-steps": 2 },
                on: { close: _vm.cancel }
              })
            ]
          }
        }
      ]),
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "div",
        { staticClass: "wizard-body" },
        [
          _vm.currentStep === 1
            ? _c("wizard-step1-select-type", {
                attrs: {
                  "document-types": _vm.documentTypes,
                  "selected-type": _vm.selectedType
                },
                on: { select: _vm.selectDocumentType }
              })
            : _vm._e(),
          _vm.currentStep === 2
            ? _c("wizard-step2-confirm", {
                attrs: {
                  "selected-type": _vm.selectedType,
                  "document-types": _vm.documentTypes,
                  location: _vm.location
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("wizard-footer", {
        attrs: {
          "current-step": _vm.currentStep,
          "can-go-next": _vm.canGoNext
        },
        on: {
          next: _vm.nextStep,
          previous: _vm.previousStep,
          cancel: _vm.cancel,
          create: _vm.createDocument
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }